import * as React from "react";
import { LayoutDashboard, Fingerprint, Lightbulb, Share2, ArrowRight } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Card } from "@/components/ui/card";
const solutions = [{
  title: "Supplier Change",
  description: "Strategic transition management to higher-performing vendors while mitigating operational risk and ensuring continuity.",
  icon: LayoutDashboard,
  link: "#lets-talk"
}, {
  title: "Competitive Bidding",
  description: "Rigorous RFP processes, e-sourcing and AI-enhanced negotiations to secure market-leading terms and significant cost reductions.",
  icon: Fingerprint,
  link: "#lets-talk"
}, {
  title: "Value Engineering",
  description: "Optimizing product specifications and materials to drive down costs without compromising quality or performance.",
  icon: Lightbulb,
  link: "#lets-talk"
}, {
  title: "Logistics Optimization",
  description: "Streamlining supply chain routes and carrier selection to reduce lead times and freight expenditures globally.",
  icon: Share2,
  link: "#lets-talk"
}];
export default function OurSignatureSolutions() {
  return <section data-section-id="223689" id="what-we-deliver" className="text-foreground py-24 px-6 md:px-12 lg:px-24 bg-muted">
      <div className="mx-auto max-w-7xl">
        <div className="mb-16 md:mb-24">
          <span className="font-default text-sm font-bold uppercase tracking-wider text-accent mb-4 block">
            Our Expertise
          </span>
          <h2 className="font-default text-4xl font-bold tracking-tight text-primary md:text-5xl lg:text-6xl">
            Strategic Sourcing Solutions
          </h2>
        </div>

        <div className="grid grid-cols-1 gap-8 md:grid-cols-2 lg:grid-cols-4 lg:gap-12">
          {solutions.map((solution, i) => <Card key={i} data-index={i} className="group relative flex min-h-[320px] flex-col rounded-lg border border-border bg-card p-0 pt-8 shadow-sm transition-all duration-500 hover:-translate-y-2 hover:border-accent">
              <div className="px-6 pb-6 md:px-8 md:pb-8 flex flex-col h-full">
                <solution.icon className="size-10 text-primary transition-transform duration-500 group-hover:scale-110" strokeWidth={1.5} />
                
                <h3 className="font-default mt-12 mb-4 text-[22px] font-semibold leading-tight tracking-tight text-primary">
                  {solution.title}
                </h3>
                
                <p className="text-muted-foreground text-base leading-relaxed font-default">
                  {solution.description}
                </p>

                <div className="mt-auto pt-8 overflow-hidden">
                  <Link to={solution.link} className="inline-flex items-center gap-2 text-sm font-bold text-accent opacity-0 -translate-x-4 transition-all duration-500 group-hover:opacity-100 group-hover:translate-x-0">
                    Learn More <ArrowRight className="size-4" />
                  </Link>
                </div>
              </div>
            </Card>)}
        </div>
      </div>
    </section>;
}